import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import API from './utils/api';
import {
    PaymentInstitutionBranchDto, PaymentInstitutionBranchPaginator,
    CreatePaymentInstitutionBranchDto, QueryPaymentInstitutionBranchDto,
    UpdatePaymentInstitutionBranchDto,
    SearchPaymentInstitutionBranchDto
} from "../models/payment-institution-branch.dto";
import ENDPOINTS from "./utils/endpoints";
import { toast } from "react-toastify";

export function useGetPaymentInstitutionBranch(options?: QueryPaymentInstitutionBranchDto) {
    const url = ENDPOINTS.BILLING_AND_SUBSCRIPTION.PAYMENT_INSTITUTION_BRANCH.GET;
    const request = (options: QueryPaymentInstitutionBranchDto) => API.BillingAndSubscriptionAPI.getPaymentInstitutionBranch(options);

    const { data, isLoading, error, refetch } = useQuery<PaymentInstitutionBranchPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch };
}

export function useGetPaymentInstitutionBranchSearch() {
    
    return useMutation(
        (options?: SearchPaymentInstitutionBranchDto) => API.BillingAndSubscriptionAPI.getPaymentInstitutionBranchSearch(options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useGetPaymentInstitutionBranchById(id: number) {
    const url = ENDPOINTS.BILLING_AND_SUBSCRIPTION.PAYMENT_INSTITUTION_BRANCH.DETAIL
    const request = API.BillingAndSubscriptionAPI.getPaymentInstitutionBranchById(id);

    const {data, isLoading, error} = useQuery<{ data:PaymentInstitutionBranchDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreatePaymentInstitutionBranch() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload}: {payload: CreatePaymentInstitutionBranchDto}) => API.BillingAndSubscriptionAPI.createPaymentInstitutionBranch(payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.BILLING_AND_SUBSCRIPTION.PAYMENT_INSTITUTION_BRANCH.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdatePaymentInstitutionBranch() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, id}: {payload: UpdatePaymentInstitutionBranchDto, id: number}) => API.BillingAndSubscriptionAPI.updatePaymentInstitutionBranch(id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.BILLING_AND_SUBSCRIPTION.PAYMENT_INSTITUTION_BRANCH.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeletePaymentInstitutionBranch() {

    return useMutation(
        ({ id }: { id: number }) => API.BillingAndSubscriptionAPI.deletePaymentInstitutionBranch(id),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}


export function useExportPaymentInstitutionBranches() {
    return useMutation(
        ({
        }: {
        }) => API.BillingAndSubscriptionAPI.exportPaymentInstitutionBranches(),
        {
            onSuccess: () => {},
            onError: API.Handlers.onErrorHandler,
            onSettled: () => {},
        }
    );
}

export function useGetPaymentInstitutionBranchTemplate() {
    return useMutation(
        () => API.BillingAndSubscriptionAPI.getUploadPaymentInstitutionBranchTemplate(),
        {
            onSuccess: () => {},
            onError: API.Handlers.onErrorHandler,
            onSettled: () => {},
        },
    );
}